// extracted by mini-css-extract-plugin
export var searchHeader = "_b8-0";
export var searchHeaderDark = "_b8-1";